/* BLACKROLL FRIDAY landing — br-bf.js (vanilla, deferred, theme-editor safe) */
(function () {
  if (window.__brbf) return; window.__brbf = true;
  var html = document.documentElement;
  function ts(v) { var t = Date.parse(v); return isNaN(t) ? null : t; }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function hero() { return document.querySelector('[data-bf-hero]'); }
  function dates() {
    var h = hero(); if (!h) return {};
    return { vip: ts(h.dataset.vipStart), sale: ts(h.dataset.saleStart), end: ts(h.dataset.saleEnd) };
  }
  function mode() { return html.getAttribute('data-bf-mode') || 'teaser'; }

  /* ---- countdowns ---- */
  function targetFor(el) {
    var d = dates(), m = mode(), k = el.getAttribute('data-bf-cd') || el.getAttribute('data-bf-bigcd');
    if (m === 'teaser' && el.dataset.teaserDate) { var td = ts(el.dataset.teaserDate); if (td) return td; }
    if (k === 'custom') return ts(el.dataset.custom);
    if (k === 'auto') return m === 'teaser' ? d.vip : m === 'vip' ? d.sale : m === 'sale' ? d.end : null;
    return d[k] || null;
  }
  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-bf-cd],[data-bf-bigcd]').forEach(function (el) {
      var t = targetFor(el), diff = t ? t - now : -1;
      if (!t || diff <= 0) { el.hidden = true; return; }
      el.hidden = false;
      var s = Math.floor(diff / 1000), set = function (u, v) { var b = el.querySelector('[data-u="' + u + '"]'); if (b && b.textContent !== v) b.textContent = v; };
      set('d', pad(Math.floor(s / 86400))); set('h', pad(Math.floor(s % 86400 / 3600))); set('m', pad(Math.floor(s % 3600 / 60))); set('s', pad(s % 60));
    });
    /* auto mode flip when a boundary passes while the page is open */
    var h = hero();
    if (h && h.dataset.mode === 'auto' && !/bf_preview=/.test(location.search)) {
      var d = dates(), n = now, m = (n >= d.sale && n < d.end) ? 'sale' : (n >= d.vip && n < d.sale) ? 'vip' : (n >= d.end) ? 'after' : 'teaser';
      if (m !== mode()) html.setAttribute('data-bf-mode', m);
    }
  }

  /* ---- tabs (ARIA, keyboard) ---- */
  function initTabs(root) {
    root.querySelectorAll('[data-bf-tabs]').forEach(function (sec) {
      var tabs = sec.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab, i) {
        if (tab.__bf) return; tab.__bf = 1;
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          var k = e.key, j = k === 'ArrowRight' ? i + 1 : k === 'ArrowLeft' ? i - 1 : -9;
          if (j === -9) return; e.preventDefault(); j = (j + tabs.length) % tabs.length; select(j); tabs[j].focus();
        });
      });
      function select(i) {
        tabs.forEach(function (t, j) {
          var on = i === j, p = document.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; if (p) p.hidden = !on;
        });
      }
    });
  }

  /* ---- SEO read-more clamp (content stays in DOM for crawlers) ---- */
  function initClamp(root) {
    root.querySelectorAll('[data-bf-clamp]').forEach(function (b) {
      var btn = b.parentNode.querySelector('[data-bf-more]'); if (!btn || btn.__bf) return; btn.__bf = 1;
      if (b.scrollHeight < 260) return;
      b.classList.add('is-clamped'); btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = b.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open); btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    });
  }

  /* ---- sticky mobile CTA: visible when the hero/form is off-screen ---- */
  function initSticky() {
    var st = document.querySelector('[data-bf-sticky]'), h = hero(); if (!st || !h || !('IntersectionObserver' in window)) return;
    st.hidden = false;
    var foot = document.querySelector('footer');
    var heroIn = true, footIn = false, upd = function () { st.classList.toggle('is-on', !heroIn && !footIn); };
    new IntersectionObserver(function (e) { heroIn = e[0].isIntersecting; upd(); }).observe(h);
    if (foot) new IntersectionObserver(function (e) { footIn = e[0].isIntersecting; upd(); }).observe(foot);
  }

  /* ---- scroll to the VIP form ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bf-to-form]'); if (!a) return;
    var href = a.getAttribute('href') || '#'; if (href !== '#' && href.charAt(0) !== '#') return;
    var input = document.querySelector('.brbf-form input[type="email"]'); if (!input) return;
    e.preventDefault();
    input.closest('.brbf-hero').scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
  });

  /* ---- focus the success / error message after submit ---- */
  function focusMsg() {
    var m = document.querySelector('[data-bf-focus]'); if (!m) return;
    m.closest('.brbf-hero').scrollIntoView({ block: 'start' }); m.focus({ preventScroll: true });
    try { window.dataLayer = window.dataLayer || []; if (m.classList.contains('brbf-form__msg--ok')) window.dataLayer.push({ event: 'bf_vip_signup', bf_locale: html.lang }); } catch (_) {}
  }

  /* ---- keep header logo/menu readable over the dark BF blocks ---- */
  function initHeader() {
    var h = document.querySelector('#header-component'); if (!h || !hero()) return;
    var busy = false;
    function upd() {
      busy = false;
      var r = h.getBoundingClientRect(), y = Math.max(1, r.bottom - 6), x = Math.round(innerWidth / 2);
      var el = document.elementsFromPoint(x, y).find(function (e) { return !e.closest('#header-group'); });
      html.classList.toggle('bf-hdr-light', !!(el && el.closest('.brbf-hero,.brbf-bigcd,.brbf-sleep__hero')));
    }
    function req() { if (!busy) { busy = true; requestAnimationFrame(upd); } }
    addEventListener('scroll', req, { passive: true }); addEventListener('resize', req); upd(); setTimeout(upd, 400);
  }

  function init(root) { initTabs(root || document); initClamp(root || document); tick(); }
  init(document); initSticky(); initHeader(); focusMsg();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
